/* =========================================================================
   ThatBiz — theme behaviour
   Ported from the Framer code components. No dependencies.
   Every module is defensive: if its markup is absent it does nothing.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = false;
  try {
    reduced =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    reduced = false;
  }

  /* --------------------------------------------------------------------
     Colour parsing.
     Theme settings arrive as hex, but CSS computed values and Liquid
     colour filters can hand back rgb()/rgba(). A hex-only parser would
     silently fall through to its fallback and paint everything in it,
     so accept both and fall back to a neutral grey.
     -------------------------------------------------------------------- */
  function parseColor(value) {
    var raw = String(value || '').trim();

    var fn = raw.match(/^rgba?\(\s*([0-9.]+)[\s,]+([0-9.]+)[\s,]+([0-9.]+)/i);
    if (fn) {
      return [Math.round(+fn[1]), Math.round(+fn[2]), Math.round(+fn[3])];
    }

    var hex = raw.replace('#', '');
    var full =
      hex.length === 3
        ? hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
        : hex.slice(0, 6);
    var n = parseInt(full, 16);
    if (full.length < 6 || isNaN(n)) return [120, 120, 124];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  /* ------------------------------------------------------- site loader */

  function initLoader() {
    var el = document.querySelector('[data-tb-loader]');
    if (!el) return;

    if (reduced) {
      el.remove();
      return;
    }

    var once = el.getAttribute('data-once') !== 'false';
    if (once) {
      var seen = false;
      try {
        seen = window.sessionStorage.getItem('tb-loader') === '1';
        window.sessionStorage.setItem('tb-loader', '1');
      } catch (e) {
        seen = false;
      }
      if (seen) {
        el.remove();
        return;
      }
    }

    el.hidden = false;
    // Hard stop: the overlay always leaves, animation finished or not.
    var ms = parseInt(el.getAttribute('data-duration'), 10) || 2300;
    window.setTimeout(function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    }, ms + 150);
  }

  /* -------------------------------------------------------- ripple grid */

  function initGrid() {
    var host = document.querySelector('[data-tb-grid]');
    if (!host) return;
    var canvas = host.querySelector('canvas');
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var base = parseColor(host.getAttribute('data-dot'));
    var lit = parseColor(host.getAttribute('data-lit'));
    var spacing = parseFloat(host.getAttribute('data-spacing')) || 26;
    var dotSize = parseFloat(host.getAttribute('data-size')) || 1.6;
    var reach = Math.max(parseFloat(host.getAttribute('data-reach')) || 190, 40);
    var strength = Math.min(
      1,
      Math.max(0, (parseFloat(host.getAttribute('data-intensity')) || 100) / 100)
    );

    var width = 0;
    var height = 0;
    var dpr = 1;
    var px = -9999;
    var py = -9999;
    var influence = 0;
    var target = 0;
    var frame = 0;
    var start = 0;

    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var box = host.getBoundingClientRect();
      width = box.width > 0 ? box.width : window.innerWidth;
      height = box.height > 0 ? box.height : window.innerHeight;
      canvas.width = Math.floor(width * dpr);
      canvas.height = Math.floor(height * dpr);
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function draw(now) {
      if (start === 0) start = now;
      var t = (now - start) / 1000;

      influence += (target - influence) * 0.09;
      ctx.clearRect(0, 0, width, height);

      var cols = Math.ceil(width / spacing) + 1;
      var rows = Math.ceil(height / spacing) + 1;
      var ox = (width - (cols - 1) * spacing) / 2;
      var oy = (height - (rows - 1) * spacing) / 2;

      for (var cx = 0; cx < cols; cx++) {
        for (var cy = 0; cy < rows; cy++) {
          var x = ox + cx * spacing;
          var y = oy + cy * spacing;

          var energy = 0;
          if (influence > 0.004) {
            var dx = x - px;
            var dy = y - py;
            var d = Math.sqrt(dx * dx + dy * dy);
            if (d < reach) {
              var falloff = 1 - d / reach;
              // concentric rings travelling outward
              var wave = 0.55 + 0.45 * Math.cos(d * 0.07 - t * 3.4);
              energy = falloff * falloff * wave * influence * strength;
            }
          }

          var r = dotSize + energy * dotSize * 2.6;
          var alpha = 0.22 + energy * 0.78;
          var cr = Math.round(base[0] + (lit[0] - base[0]) * energy);
          var cg = Math.round(base[1] + (lit[1] - base[1]) * energy);
          var cb = Math.round(base[2] + (lit[2] - base[2]) * energy);
          ctx.fillStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + alpha + ')';

          if (energy > 0.04) {
            ctx.beginPath();
            ctx.arc(x, y, r, 0, Math.PI * 2);
            ctx.fill();
          } else {
            ctx.fillRect(x - r / 2, y - r / 2, r, r);
          }
        }
      }

      // Keep running while anything is still easing; otherwise idle.
      if (influence > 0.004 || target > 0) {
        frame = window.requestAnimationFrame(draw);
      } else {
        frame = 0;
        influence = 0;
      }
    }

    function kick() {
      if (frame === 0) frame = window.requestAnimationFrame(draw);
    }

    resize();
    draw(performance.now());

    if (!reduced) {
      window.addEventListener(
        'pointermove',
        function (e) {
          px = e.clientX;
          py = e.clientY;
          target = 1;
          kick();
        },
        { passive: true }
      );
      var leave = function () {
        target = 0;
        kick();
      };
      window.addEventListener('pointerleave', leave);
      document.addEventListener('pointerleave', leave);
    }

    window.addEventListener('resize', function () {
      resize();
      if (frame === 0) draw(performance.now());
    });
  }

  /* ----------------------------------------------------------- line menu */

  function initRail() {
    var rail = document.querySelector('[data-tb-rail]');
    if (!rail) return;
    var links = [].slice.call(rail.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    var showAfter = parseFloat(rail.getAttribute('data-show-after')) || 80;

    function onScroll() {
      var past = window.scrollY > (window.innerHeight * showAfter) / 100;
      rail.classList.toggle('is-on', past);

      // nearest section whose top is above the viewport middle
      var current = '';
      links.forEach(function (a) {
        var id = a.getAttribute('href').slice(1);
        var el = document.getElementById(id);
        if (!el) return;
        if (el.getBoundingClientRect().top <= window.innerHeight * 0.5) current = id;
      });
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('href').slice(1) === current);
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ------------------------------------------------------ progress steps */

  function initSteps() {
    var root = document.querySelector('[data-tb-steps]');
    if (!root) return;
    var fill = root.querySelector('.tb-steps__fill');
    var head = root.querySelector('.tb-steps__head');
    var steps = [].slice.call(root.querySelectorAll('.tb-step'));
    var dials = steps.map(function (s) {
      return s.querySelector('.tb-step__dial');
    });
    if (!fill || !steps.length) return;

    var startAt = parseFloat(root.getAttribute('data-start')) || 85;
    var endAt = parseFloat(root.getAttribute('data-end')) || 35;
    var frame = 0;

    function update() {
      frame = 0;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var upright = window.innerWidth <= 1262;

      // Upright: the fill tracks whichever step is near the reading line.
      // Across: it sweeps while the row crosses the viewport.
      var ratio = upright
        ? (vh * 0.6 - rect.top) / Math.max(rect.height, 1)
        : (vh * (startAt / 100) - rect.top) / Math.max(vh * ((startAt - endAt) / 100), 1);
      var progress = Math.min(1, Math.max(0, ratio));
      var pct = (progress * 100).toFixed(2) + '%';

      if (upright) {
        fill.style.height = pct;
        fill.style.width = '';
        if (head) head.style.top = pct;
      } else {
        fill.style.width = pct;
        fill.style.height = '';
        if (head) head.style.left = pct;
      }
      if (head) head.style.opacity = progress > 0.02 && progress < 0.99 ? '1' : '0';

      // Dial positions are measured, not assumed, so the lighting stays
      // correct at every breakpoint.
      var span = upright ? rect.height : rect.width;
      dials.forEach(function (dial, i) {
        if (!dial) return;
        var d = dial.getBoundingClientRect();
        var centre = upright
          ? d.top + d.height / 2 - rect.top
          : d.left + d.width / 2 - rect.left;
        var mark = span > 0 ? Math.min(1, Math.max(0, centre / span)) : i / Math.max(steps.length - 1, 1);
        steps[i].classList.toggle('is-lit', progress >= mark);
      });
    }

    function onScroll() {
      if (frame === 0) frame = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  /* ---------------------------------------------- in-view reveal (cards) */

  function initInView() {
    var groups = [].slice.call(document.querySelectorAll('[data-tb-inview]'));
    if (!groups.length) return;

    if (typeof IntersectionObserver === 'undefined') {
      groups.forEach(function (g) {
        g.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );
    groups.forEach(function (g) {
      io.observe(g);
    });
  }

  /* ------------------------------------------------------------- starfield
     A tiny deterministic PRNG so the stars land in the same place on every
     render; Math.random would reshuffle them on each page view. */

  function initStars() {
    var host = document.querySelector("[data-tb-stars]");
    if (!host || host.childNodes.length) return;

    var count = parseInt(host.getAttribute("data-count"), 10);
    if (isNaN(count) || count <= 0) return;
    var horizon = parseFloat(host.getAttribute("data-horizon")) || 72;
    var s = (parseInt(host.getAttribute("data-seed"), 10) || 7) * 2654435761;
    s = s >>> 0 || 1;

    function next() {
      s ^= s << 13;
      s ^= s >>> 17;
      s ^= s << 5;
      s >>>= 0;
      return s / 4294967296;
    }

    var limit = Math.max(horizon - 6, 1);
    var html = "";
    for (var i = 0; i < count; i++) {
      var x = next() * 100;
      var y = next() * limit;
      var r = 0.6 + next() * 1.1;
      // fade them out as they approach the horizon glow
      var o = (0.25 + next() * 0.6) * (1 - y / limit);
      var d = next() * 5;
      html +=
        "<i style=\"left:" + x.toFixed(3) + "%;top:" + y.toFixed(3) +
        "%;width:" + r.toFixed(2) + "px;height:" + r.toFixed(2) +
        "px;opacity:" + o.toFixed(3) + ";--o:" + o.toFixed(3) +
        ";animation-delay:" + d.toFixed(2) + "s\"></i>";
    }
    host.innerHTML = html;
  }
  /* ------------------------------------------------ footer cursor reveal */

  function initGiant() {
    var giant = document.querySelector('[data-tb-giant]');
    if (!giant) return;
    var lit = giant.querySelector('.tb-giant__lit');
    if (!lit) return;

    giant.addEventListener('pointermove', function (e) {
      var box = giant.getBoundingClientRect();
      giant.style.setProperty('--gx', e.clientX - box.left + 'px');
      giant.style.setProperty('--gy', e.clientY - box.top + 'px');
      giant.style.setProperty('--gr', Math.max(130, box.width * 0.13) + 'px');
      // A zero-radius radial-gradient is a degenerate case that some engines
      // paint as fully opaque, so gate the layer explicitly rather than
      // relying on the mask alone.
      lit.style.opacity = '1';
    });

    giant.addEventListener('pointerleave', function () {
      giant.style.setProperty('--gr', '0px');
      lit.style.opacity = '0';
    });
  }

  /* ----------------------------------------------------- mobile nav drawer */

  function initDrawer() {
    var burger = document.querySelector('[data-tb-burger]');
    var drawer = document.querySelector('[data-tb-drawer]');
    if (!burger || !drawer) return;

    burger.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        drawer.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* --------------------------------------------------------------- boot */

  function boot() {
    initLoader();
    initGrid();
    initRail();
    initSteps();
    initInView();
    initStars();
    initGiant();
    initDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify's theme editor tears sections down and rebuilds them.
  document.addEventListener('shopify:section:load', boot);
})();
